import React from 'react'
import { Image } from '@ztechapps/webui.util'

export const Logo = ({ type = 'black' }: { type?: 'white' | 'black' }) => {
  return <Image url={`/images/logo${type === 'white' ? '-white' : ''}.png`} name="Panelpunches logo" />
}
